function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M454.3,258.6l-55.7-86c-4.3-6.7-11.6-10.6-19.6-10.6H133.2c-7.9,0-15.2,4-19.6,10.6l-55.9,86 c-5.7,8.8-4.8,20.4,2.1,28.2l178.7,200.6c4.4,5,10.8,7.8,17.4,7.8c6.6,0,13-2.8,17.4-7.8l178.7-200.6 C459.1,279,459.9,267.4,454.3,258.6 M367.7,181.9l-46.8,72.4L274,181.9H367.7z M302.5,262.8h-92.9L256,191L302.5,262.8z M238,181.9 l-46.7,72.2l-46.7-72.2H238z M126,190.2l47,72.6H78.9L126,190.2z M83.1,282.8h100.6L237,455.5L83.1,282.8z M256,449.3l-51.3-166.5 h102.6L256,449.3z M275,455.5l53.2-172.7h100.7L275,455.5z M339.2,262.8l46.9-72.6l47,72.6H339.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M30.3,262.8H10c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10h20.3c5.5,0,10-4.5,10-10 C40.3,267.3,35.9,262.8,30.3,262.8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M502,262.8h-20.3c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10H502c5.5,0,10-4.5,10-10 C512,267.3,507.5,262.8,502,262.8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M437.1,91.8c-3.9-3.9-10.2-3.9-14.1,0L389.8,125c-3.9,3.9-3.9,10.2,0,14.1c2,2,4.5,2.9,7.1,2.9 c2.6,0,5.1-1,7.1-2.9l33.2-33.2C441.1,102.1,441.1,95.7,437.1,91.8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M122.6,124.9L89.4,91.6c-3.9-3.9-10.2-3.9-14.1,0c-3.9,3.9-3.9,10.2,0,14.1l33.2,33.2c2,2,4.5,2.9,7.1,2.9 c2.6,0,5.1-1,7.1-2.9C126.6,135.1,126.6,128.8,122.6,124.9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M256.3,16.8c-5.5,0-10,4.5-10,10V92c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10V26.8 C266.3,21.3,261.8,16.8,256.3,16.8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M263.3,118.7c-1.9-1.9-4.4-2.9-7.1-2.9c-2.6,0-5.2,1.1-7.1,2.9c-1.9,1.9-2.9,4.4-2.9,7.1 c0,2.6,1.1,5.2,2.9,7.1c1.9,1.9,4.4,2.9,7.1,2.9c2.6,0,5.2-1.1,7.1-2.9c1.9-1.9,2.9-4.4,2.9-7.1S265.2,120.6,263.3,118.7"
});

var SvgAuValores = function SvgAuValores(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuValores, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/au-valores.028c18d3.svg";
export { ForwardRef as ReactComponent };